module.exports = __webpack_public_path__ + "static/media/githubrepo.b0adda39.png";